export const CTA = {
  PICKUP_URL: "$pickupUrl$",
  DELIVERY_URL: "$deliveryUrl$",
};
